import { sizes } from '../viewport';

export function media(...viewports: string[]) {
    return viewports
        .map((v) =>
            sizes[v][1]
                ? `(min-width: ${sizes[v][0]}px) and (max-width: ${sizes[v][1]}px)`
                : `(min-width: ${sizes[v][0]}px)`
        )
        .join(',');
}
